import { render, staticRenderFns } from "./MoleculeSwitch.vue?vue&type=template&id=c69455d8&scoped=true&"
import script from "./MoleculeSwitch.vue?vue&type=script&lang=js&"
export * from "./MoleculeSwitch.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeSwitch.vue?vue&type=style&index=0&id=c69455d8&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c69455d8",
  null
  
)

export default component.exports